import EpiContext from '@episerver/spa-core/Spa';
import React, {useEffect, useState} from 'react';
import {isMobile} from 'react-device-detect';
import {connect} from 'react-redux';
import {Col, Row} from 'reactstrap';
import Config from '../../../Config';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import ErrorBlock from '../../Shared/ErrorPage/ErrorBlock';
import {hideAppLoader, showAppLoader} from '../../Shared/Loader/LoaderSlice';
import PopUp from '../../Shared/Popup/PopUp';
import ValidationInputsWithRadio from '../../Shared/ValidationInputsWithRadio/ValidationInputsWithRadio';
import HeadLineComponent from '../AbroadBusinessIndividualBlock/HeadlineComponent';
import ChangeHetPayPopUp from '../ClientInformationBlock/ChangeHetPayPopUp';
import {
  AddSurfingPackageForBusiness,
  GetCustomerDetailsForBusinessContactManager,
  GetDataUsage,
  reportDWH,
  setAddPackageSuccess,
  setCustomerNumber,
  setIsShowPopup,
  setIsShowSocPopUp,
  setSelectedOffer,
  setSelectedSubscriber,
} from '../PortalsBlock/portalSlice';
import BusinessDataUsagePopUp from './BusinessDataUsagePopUp';
import {reportDWHBuilder} from './reportDWH';
import {gtag4} from '../../../utilities/analytics/tracking';

export const BusinessDataUsageMain = (props) => {
  const reportDWH = (mode, params) => {
    const report = reportDWHBuilder(mode, params, props);
    props.reportDWH(report);
  };

  useEffect(() => {
    if (!oldHetPay.id) {
      getOldHetPayName();
    }
    reportDWH('DISPLAY_SEARCH_PAGE');
    gtag4({
      event: 'BrowsingInfo_PhoneNumPage',
      action: 'PhoneNumPage',
    });
  }, []);

  const getOldHetPayName = () => {
    props.portalState?.hetPaysNumbers?.map((h) => {
      if (h.id === props.portalState.selectedHetPay)
        setOldHetPay({
          id: h.id,
          name: h.name,
        });
    });
  };
  let data = props.iContent;
  const form = [
    {
      inputName: 'מספר טלפון',
      id: 1,
      formType: 'PHONE',
      pattern: '[0-9]*',
      maxLength: '10',
      regexPattern: '^[0-9]{10}$',
    },
  ];

  const [typedNumber, setTypedNumber] = useState({
    id: null,
    value: '',
  });

  const [formType, setFormType] = useState({
    id: '',
    formType: '',
  });

  const [isAllowed, setIsAllowed] = useState({
    description: 'initialState',
    isAllowed: false,
  });
  const [dataUsage, setDataUsage] = useState(null);
  const [oldHetPay, setOldHetPay] = useState({
    id: '',
    name: '',
  });
  const [showSocOffers, setShowSocOffers] = useState(false);

  let pattern = new RegExp('^.*[a-zA-Z0-9]+.*$');
  const patternTest = () => {
    form.map((f) => {
      if (f.id === typedNumber.id || form.length == 1) {
        if (f.regexPattern) {
          pattern = new RegExp(f.regexPattern);
        } else {
          pattern = new RegExp('^.*[a-zA-Z0-9]+.*$');
        }
      }
    });
  };
  patternTest();

  async function getCustomerNumber(customerNumber) {
    reportDWH('SEARCH_BTN_CLICK');
    gtag4({
      event: 'BrowsingInfo_PhoneNumContinueButton',
      action: 'PhoneNumContinueButton',
    });
    try {
      props.showAppLoader();
      let orgId;
      setIsAllowed({description: 'isLoading'});
      props.setCustomerNumber(customerNumber);
      props.portalState.privateCompanyList.map((company) => {
        if (company.idNumber === props.portalState?.selectedHetPay) {
          return (orgId = company.orgId);
        }
      });
      const requestBody = {
        orgId: orgId,
        selectedNumber: customerNumber,
        isPrivate: true,
        blockId: props.iContent.contentLink.id,
        isRefresh: false,
        isBusiness: true,
      };
      const result = await props.GetDataUsage(requestBody);

      setIsAllowed(result.payload.validation);
      setIsAllowed({...isAllowed, newOrgName: result.payload.validation.orgName});
      setDataUsage(result.payload.surfingDetails);
      if (result.payload.isEligibleForSocOffers) {
        reportDWH('PACKAGES_DISPLAYED');
      }
      setShowSocOffers(result.payload.isEligibleForSocOffers);
      if (result.payload.validation.description === 'MemberOfDifferentOrg' || result.payload.validation.description === 'OrgIdNotFound') {
        props.setIsShowPopup(true);
      } else if (result.payload.validation.description === 'AccountNotFound') {
        setIsAllowed({
          description: 'AccountNotFound',
          isAllowed: false,
        });
      }
      switch (result.payload.description) {
        case 'MemberOfDifferentOrg' || 'OrgIdNotFound':
          props.setIsShowPopup(true);
          reportDWH('SUB_DIFF_ORG');
          break;
        case 'PhoneNumberNotFound':
          reportDWH('SUB_NOT_FOUND');
          break;
      }
      if (result.payload.error) {
        reportDWH('SEARCH_GEN_ERR');
      }
      if (result.payload.validation.isAllowed == true) {
        reportDWH('DISPLAY_DATA');
        gtag4({
          event: 'BrowsingInfo_DataPage',
          action: 'DataPage',
        });
        setIsAllowed({
          ...isAllowed,
          description: 'displayDataUsage',
        });
      }
      props.hideAppLoader();
    } catch (error) {
      setIsAllowed({...isAllowed, description: 'error'});
      props.hideAppLoader();
    }
  }
  const onButtonClick = () => {
    setIsAllowed({
      ...isAllowed,
      isAllowed: true,
      description: 'displayDataUsage',
    });
    props.setIsShowPopup(false);
  };
  const onPopupClosing = () => {
    props.setIsShowPopup(false);
    setIsAllowed({
      description: 'initialState',
    });
    return props.isShowPopup;
  };

  const handleSearchAnotherNumber = () => {
    reportDWH('ANOTHER_SUB');
    setIsAllowed({
      ...isAllowed,
      description: 'initialState',
    });
  };

  const getCustomerValidationErrorDescription = () => {
    let error;
    if (isAllowed.description == 'PhoneNumberNotFound') {
      error = `לא נמצא מנוי, אנא נסה שוב`;
    } else if (isAllowed.description == 'AccountNotFound') {
      error = `מנוי זה לא משוייך לאחד מהארגונים שלך, אנא נסה שוב`;
    } else if (isAllowed.description == 'MemberOfDifferentOrg') {
      error = `מנוי זה משוייך לארגון אחר, אנא נסה שוב`;
    } else if (isAllowed.description == 'ErrorOnValidation' || isAllowed.description == 'Unknown' || isAllowed.error) {
      error = `קרתה תקלה במהלך הזיהוי, אנא נסה שוב`;
    }
    return error;
  };

  const getButtonModes = () => {
    if (isAllowed.description === 'initialState') {
      return (
        <>
          <Row className='justify-content-center mt-5'>
            <Col xs='12' className={`btn-220 btn-row pr-0 pl-0 text-center ${!pattern.test(typedNumber.value) && 'disabled-btn'}`}>
              <BtnSubmit isBusiness text={`המשך`} onclick={() => getCustomerNumber(typedNumber.value, formType.formType)} />
            </Col>
          </Row>
          <Row className='justify-content-center mt-2'>
            <Col xs='12' className={`btn-220 btn-row pr-0 pl-0 text-center }`}>
              <BtnWhite isBusiness text={`חזרה לאיזור האישי`} onclick={() => EpiContext.navigateTo(Config.businessLobbyUrl)} />
            </Col>
          </Row>
        </>
      );
    } else if ((isAllowed.isAllowed == false || isAllowed.error) && isAllowed.description !== 'MemberOfDifferentOrg') {
      return (
        <>
          <Row className='account-denied text-center  mt-4'>
            <Col xs='12' className='justify-content-center pr-0 pl-0'>
              <p className='font-14 newPurple-text mb-1'>{getCustomerValidationErrorDescription()}</p>
            </Col>
            <Col xs='12' className='justify-content-center pr-0 pl-0'>
              {isMobile ? (
                <a href={`tel:${window.Config.businessCallNumber}`} className='font-14 bold asBtn'>
                  אחרת חייג 234* לשיחה עם צוותון שירות
                </a>
              ) : (
                <p className='font-14 bold mb-0'>חיוג 234* לשיחה עם צוותון שירות</p>
              )}
            </Col>
          </Row>
          <Row className='justify-content-center mt-3'>
            <Col xs='12' className={`btn-220 btn-row pr-0 pl-0 text-center ${!pattern.test(typedNumber.value) ? 'disabled-btn' : ''}`}>
              <BtnSubmit isBusiness text={`נסה שוב`} onclick={() => getCustomerNumber(typedNumber.value, formType.formType)} />
            </Col>
          </Row>
          <Row className='justify-content-center mt-2'>
            <Col xs='12' className={`btn-220 btn-row pr-0 pl-0 text-center }`}>
              <BtnWhite isBusiness text={`חזרה לאיזור האישי`} onclick={() => EpiContext.navigateTo(Config.businessLobbyUrl)} />
            </Col>
          </Row>
        </>
      );
    } else if (isAllowed.isAllowed == true && isAllowed.description === 'displayDataUsage') {
      return (
        <>
          <Row className='justify-content-center mt-5'>
            <Col xs='12' className={'btn-220 btn-row pr-0 pl-0 text-center'}>
              <BtnSubmit isBusiness text={`להזנת מספר טלפון נוסף`} onclick={handleSearchAnotherNumber} />
            </Col>
          </Row>
          <Row className='justify-content-center mt-2'>
            <Col xs='12' className={`btn-220 btn-row pr-0 pl-0 text-center }`}>
              <BtnWhite isBusiness text={`חזרה לאיזור האישי`} onclick={() => EpiContext.navigateTo(Config.businessLobbyUrl)} />
            </Col>
          </Row>
        </>
      );
    }
  };
  const backToBusinessLobby = () => {
    props.setIsShowSocPopUp(false);
    props.setAddPackageSuccess(null);
    EpiContext.navigateTo(Config.businessLobbyUrl);
  };
  const addPackage = async () => {
    reportDWH('PURCHASE_BTN_CLICKED');
    gtag4({
      event: 'BrowsingInfo_PackageExpansionPurchasedButton',
      action: 'PackageExpansionPurchasedButton',
    });
    let orgId;
    props.portalState?.privateCompanyList.map((company) => {
      if (company.idNumber === props.portalState?.selectedHetPay) {
        return (orgId = company.orgId);
      }
    });
    props.setIsShowSocPopUp(false);
    props.showAppLoader();
    let result = await props.AddSurfingPackageForBusiness({
      orgId: orgId,
      subscriberNo: props.portalState.customerPhoneNumber,
      socBlockId: props.portalState.selectedOffer.contentLink.id,
    });
    props.setAddPackageSuccess(result.payload.success);
    props.hideAppLoader();
    props.setIsShowSocPopUp(true);
  };

  const closeSocPopUp = () => {
    gtag4({
      event: 'BrowsingInfo_PackageExpansionReturnButton',
      action: 'PackageExpansionReturnButton',
    });
    props.setIsShowSocPopUp(false);
  };

  const socPopUpContent = () => {
    switch (props.portalState.addPackageSuccess) {
      case true:
        reportDWH('PURCHASE_SUCCESS');
        gtag4({
          event: 'BrowsingInfo_PurchaseSuccessfulPage',
          action: 'PurchaseSuccessfulPage',
        });
        return (
          <div className='soc-popup-content'>
            <h2>הרחבת הגלישה הותקנה בהצלחה</h2>
            <p>הרחבת חבילת הגלישה מתווספת לחבילה המקורית ומתחדשת באופן אוטומטי</p>
            <div className='btn-wrapper'>
              <BtnWhite isBusiness text={`חזרה לאיזור האישי`} onclick={backToBusinessLobby} />
            </div>
          </div>
        );
      case false:
        reportDWH('GEN_ERR');
        return (
          <div className='soc-popup-content'>
            <h2>שגיאה</h2>
            <p className='offer-text'>לקוח יקר, לא ניתן להתקדם בתהליך, נא פנה לאחראי\ת שירות להמשך טיפול.</p>
            <div className='btn-wrapper'>
              <BtnWhite isBusiness text={`חזרה לאיזור האישי`} onclick={backToBusinessLobby} />
            </div>
          </div>
        );
      default:
        return (
          <div className='soc-popup-content'>
            <h2>הרחבת חבילת גלישה</h2>
            {props.isPrivate && (
              <p className='offer-text'>
                האם ברצונכם לרכוש תוספת קבועה של {props.portalState?.selectedOffer?.soc?.value} לחבילת הגלישה בעלות חודשית של ₪
                {props.portalState?.selectedOffer?.price?.value} כולל מע"מ?
              </p>
            )}
            {!props.isPrivate && (
              <p className='offer-text'>
                האם ברצונכם לרכוש תוספת קבועה של {props.portalState?.selectedOffer?.soc?.value} לחבילת הגלישה בעלות חודשית של ₪
                {props.portalState?.selectedOffer?.price?.value} כולל מע"מ?
              </p>
            )}
            <p>החבילה מתווספת לחבילה המקורית ומתחדשת באופן אוטומטי</p>
            <div className='btn-wrapper'>
              <BtnSubmit onclick={addPackage} text='כן, אני רוצה לרכוש' formid='cellularDataUsage'></BtnSubmit>
              <BtnWhite onclick={closeSocPopUp} text='לא, תודה' formid='cellularDataUsage'></BtnWhite>
            </div>
          </div>
        );
    }
  };
  return (
    <div className='business-data-usage'>
      <div className='main-container'>
        {(isAllowed?.description == 'initialState' ||
          isAllowed?.description == 'AccountNotFound' ||
          isAllowed?.description == 'PhoneNumberNotFound') && (
          <ValidationInputsWithRadio
            onButtonClick={getCustomerNumber}
            data={dataUsage}
            form={form}
            typedNumber={typedNumber}
            setTypedNumber={setTypedNumber}
            formType={formType}
            setFormType={setFormType}
            getButtonModes={getButtonModes}
            title={data?.title?.value}
            boldTitle={
              isAllowed?.description == 'initialState' ||
              isAllowed?.description == 'AccountNotFound' ||
              isAllowed?.description == 'PhoneNumberNotFound'
                ? data?.boldTitle?.value
                : null
            }
          />
        )}
        <PopUp showPopUp={props.portalState.isShowPopup} onClose={() => onPopupClosing()}>
          <ChangeHetPayPopUp
            isAllowed={isAllowed}
            setIsAllowed={setIsAllowed}
            oldHetPay={oldHetPay}
            setIsShowPopup={props.setIsShowPopup}
            btnText={'קבלת נתוני גלישה'}
            onButtonClick={onButtonClick}
          />
        </PopUp>
        {isAllowed?.description == 'displayDataUsage' && (
          <>
            <HeadLineComponent
              title={data?.title?.value}
              boldTitle={isAllowed?.description == 'initialState' ? data?.boldTitle?.value : null}
            />
            <BusinessDataUsagePopUp
              showSocOffers={showSocOffers}
              dataUsage={dataUsage}
              availableSocs={props.iContent.items.expandedValue}
              setSelectedSubscriber={props.setSelectedSubscriber}
              setIsShowSocPopUp={props.setIsShowSocPopUp}
              setSelectedOffer={props.setSelectedOffer}
              dataOfferThresholdPercentage={props.iContent.dataOfferThresholdPercentage.value}
            />
            <Row className='justify-content-center mt-5'>
              <Col xs='12' className={'btn-220 btn-row pr-0 pl-0 text-center'}>
                <BtnSubmit isBusiness text={`להזנת מספר טלפון נוסף`} onclick={handleSearchAnotherNumber} />
              </Col>
            </Row>
            <Row className='justify-content-center mt-2'>
              <Col xs='12' className={`btn-220 btn-row pr-0 pl-0 text-center }`}>
                <BtnWhite isBusiness text={`חזרה לאיזור האישי`} onclick={() => EpiContext.navigateTo(Config.businessLobbyUrl)} />
              </Col>
            </Row>
          </>
        )}
        {isAllowed?.description == 'error' && (
          <ErrorBlock mainTitle='אופס, משהו השתבש!' buttonTitle={'חזרה לאיזור האישי'} buttonLink={Config.businessLobbyUrl} />
        )}
        <PopUp
          className='surfing-use-popup'
          showPopUp={props.portalState?.isShowSocPopUp}
          onClose={() => {
            props.setIsShowSocPopUp(false);
          }}>
          {socPopUpContent()}
        </PopUp>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    portalState: state.portalsBlock,
  };
};

const mapDispatchToProps = {
  setCustomerNumber,
  GetCustomerDetailsForBusinessContactManager,
  showAppLoader,
  hideAppLoader,
  setIsShowPopup,
  setIsShowSocPopUp,
  GetDataUsage,
  setSelectedSubscriber,
  setSelectedOffer,
  setAddPackageSuccess,
  AddSurfingPackageForBusiness,
  reportDWH,
};

export default connect(mapStateToProps, mapDispatchToProps)(BusinessDataUsageMain);
